import React from "react";

const CommentingPolicies = () => {
  return (
    <React.Fragment>
      <h1>Commenting Policies</h1>
      <p>
        Users must sign in to their Cureus Journals profile to comment on an article. Under no
        circumstances do Cureus Journals allow anonymous or pseudonymous commenting or user
        profiles. Additionally, Cureus Journals maintain a zero-tolerance policy for any language
        deemed insulting, inflammatory, obscene, or libelous.
      </p>
      <p>
        All comments that do not meet these standards will be removed, while repeat offenders will
        have their commenting rights revoked.
      </p>
      <h2>
        <strong>Communicating with Respect</strong>
      </h2>
      <p>
        Authors, reviewers, editors, and readers are expected to engage professionally and
        respectfully at all times. Similarly, we uphold these standards for the academic community
        and the public in their interactions with our team. Aggressive behavior, harassment,
        bullying, or discrimination will not be tolerated. In serious cases, we reserve the right to
        notify employers and law enforcement. We may also refuse to interact or conduct business
        with individuals who repeatedly or seriously violate this policy.
      </p>
    </React.Fragment>
  );
};

export default CommentingPolicies;
